<template>
  <div class="header-common">
    <div class="page-title">{{page}}</div>    
  </div>
</template>
<script>
export default {
  props: {
    page: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.header-common {
  width: 80%;
  padding: 30px;
  padding-left: 45px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  .page-title {
    font-weight: bold;
    font-size: 20px;
  }
  .logo-home {
    img {
      width: 180px;
    }
  }
}
</style>